export { default } from './Modal';



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/index.js